import style from "./main.module.scss";

const CartFooter = ({
  backCta: BackCta,
  cancelCta: CancelCta,
  skipCta: SkipCta,
  nextCta: NextCta,
  showBackCta = true,
  containerClass = "",
  className = "",
  footerMessageContent = null,
}) => (
  <footer className={`${style.orderFooter} ${style.createOrderFooter} ${className}`}>
    {footerMessageContent}
    <div className={`${style.pageContainer} ${containerClass}`}>
      <div className={style.row}>
        <div className={style.leftCol}>
          {showBackCta && BackCta && <BackCta />}
          {CancelCta && <CancelCta />}
        </div>
        <div className={style.rightCol}>
          <div className={style.footerHolder}>
            <div className={style.skipBtnWeb}>{SkipCta && <SkipCta />}</div>
            {NextCta && <NextCta />}
          </div>
        </div>
        <div className={style.mobileBlock}></div>
      </div>
    </div>
  </footer>
);

export default CartFooter;
